import {Master} from './master';

export class TalepKalem {
  id: number;
  stokKodu: string;
  stokAdi: string;
  talepEdilen: number;
  olcuBirimi: string;
  sarfYeriId: number;
  gecenSure: number;
  sonAlisFiyati: number;
  dovizTipi: number;
  paraBirimiId: number = null;
  firmaTeklifi: number = null;
  toplamSiparisMiktar: number;
  tutar: number;
  dovizAciklama: string;

  sarfYeri: Master = null;
  paraBirimi: Master = null;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.sarfYeri != null) {
      this.sarfYeri = new Master(obj.sarfYeri);
    }
    if (obj.paraBirimi != null) {
      this.paraBirimi = new Master(obj.paraBirimi);
    }
  }
}
